/** * * Asynchronously loads the component for
Fixed Phone
* */ import { lazyLoad } from "utils/loadable";
export const FixedPhone = lazyLoad(
  () => import("./index"),
  (module) => module.FixedPhone
);
